import apiClient from '@/utils/axios'

const notification = {
  async getNotification() {
    const response = await apiClient.get('/notifications')
    return response
  },

  async notificationsByPage(page) {
    const response = await apiClient.get('/notifications', {
      params: {page},
    })
    return response
  },

  async getActor(id) {
    const response = await apiClient.get('/users/' + id)
    return response
  },

  async readNotification() {
    const response = await apiClient.get('/readasmark/notifications')
    return response
  },

  async getNewNotification() {
    const response = await apiClient.get('/newnotifications')
    return response
  },

  async getNotificationCount() {
    const response = await apiClient.get('/count_notifications')
    return response
  },

  async getNewNotificationCount() {
    const response = await apiClient.get('/count_newnotifications')
    return response
  },

  async getNewLawyerCount() {
    const response = await apiClient.get('/count_new_lawyer')
    return response
  },
}

export {notification}
